import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/invoices',
    name: 'Costs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Costs.vue')
  },
  {
    path: '/invoice/:costId',
    name: 'Cost',
    component: () => import('../views/Cost.vue')
  },
  {
    path: '/new-invoice/:costId',
    name: 'NewCost',
    component: () => import('../views/NewCost.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/change-password/:key',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue')
  },
  {
    path: '/my-config',
    name: 'MyConfig',
    component: () => import('../views/MyConfig.vue')
  },
  {
    path: '/config-vendors',
    name: 'Vendors',
    component: () => import('../views/Vendors.vue')
  },
  {
    path: '/config-accounts',
    name: 'Accounts',
    component: () => import('../views/Accounts.vue')
  },
  {
    path: '/config-locations',
    name: 'Locations',
    component: () => import('../views/Locations.vue')
  },
  {
    path: '/config-classes',
    name: 'Locations',
    component: () => import('../views/MyClasses.vue')
  },
  {
    path: '/dev-tools',
    name: 'DevTools',
    component: () => import('../views/DevTools.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/price-analysis',
    name: 'PriceAnalysis',
    component: () => import('../views/PriceAnalysis.vue')
  },
  {
    path: '/product/:productId',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/products-sales',
    name: 'ProductsSales',
    component: () => import('../views/ProductsSales.vue')
  },
  {
    path: '/sales-monitor',
    name: 'SalesMonitor',
    component: () => import('../views/SalesMonitor.vue')
  },
  {
    path: '/sales-summary/:itemId',
    name: 'SalesSummary',
    component: () => import('../views/SalesSummary.vue')
  },
  {
    path: '/product-sales/:nsIdIndex',
    name: 'ProductSales',
    component: () => import('../views/ProductSales.vue')
  },
  {
    path: '/product-inventory/:nsIdIndex',
    name: 'ProductInventory',
    component: () => import('../views/ProductInventory.vue')
  },
  {
    path: '/products-landed-costs',
    name: 'ProductsLandedCosts',
    component: () => import('../views/ProductsLandedCosts.vue')
  },
  {
    path: '/returned-items',
    name: 'ReturnedItems',
    component: () => import('../views/ReturnedItems.vue')
  },
  {
    path: '/returns/view/:viewId/:viewCode/:viewName',
    name: 'ReturnedItemsView',
    component: () => import('../views/ReturnedItemsView.vue')
  },
  {
    path: '/forecast',
    name: 'Forecast',
    component: () => import('../views/Forecast.vue')
  },
  {
    path: '/forecast-canada',
    name: 'ForecastCanada',
    component: () => import('../views/ForecastCanada.vue')
  },
  {
    path: '/purchase-orders',
    name: 'PurchaseOrders',
    component: () => import('../views/PurchaseOrders.vue')
  },
  {
    path: '/purchase-order/:poId',
    name: 'PurchaseOrder',
    component: () => import('../views/PurchaseOrder.vue')
  },
  {
    path: '/vendor-purchase-orders/:vendorId',
    name: 'VendorPurchaseOrders',
    component: () => import('../views/PurchaseOrders.vue')
  },
  {
    path: '/vendor-purchase-order/:vendorId/:poId',
    name: 'VendorPurchaseOrder',
    component: () => import('../views/PurchaseOrder.vue')
  },
  {
    path: '/inbounds',
    name: 'Inbounds',
    component: () => import('../views/Inbounds.vue')
  },
  {
    path: '/inbounds-map/:inboundId',
    name: 'InboundsMap',
    component: () => import('../views/InboundsMap.vue')
  },
  {
    path: '/inbound/:inboundId',
    name: 'Inbound',
    component: () => import('../views/Inbound.vue')
  },
  {
    path: '/vendor-inbounds/:vendorId',
    name: 'VendorInbounds',
    component: () => import('../views/Inbounds.vue')
  },
  {
    path: '/vendor-inbound/:vendorId/:inboundId',
    name: 'VendorInbound',
    component: () => import('../views/Inbound.vue')
  },
  {
    path: '/sale-speed/:country/:productId',
    name: 'SaleSpeed',
    component: () => import('../views/SaleSpeed.vue')
  },
  {
    path: '/chat',
    name: 'ChatView',
    component: () => import('../views/ChatView.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
